const PokemonOthers = {
    "pokemon-pokeball":{
        "type":"svg",
        "content":"pokemon-others/pokeball",
        "nicename": "Pokémon - Pokéball"
    },
    "pokemon-tm":{
        "type":"png",
        "content":"pokemon-others/pokemon-tm",
        "nicename": "Pokémon - Technical Machine (TM)"
    },
    "pokemon-bicycle":{
        "type":"png",
        "content":"pokemon-others/pokemon-bicycle",
        "nicename": "Pokémon - Bicycle"
    },
    "pokemon-basement-key":{
        "type":"png",
        "content":"pokemon-others/pokemon-basement-key",
        "nicename": "Pokémon - Basement key"
    },
    "pokemon-blue-card":{
        "type":"png",
        "content":"pokemon-others/pokemon-blue-card",
        "nicename": "Pokémon - Blue card"
    },
    "pokemon-card-key":{
        "type":"png",
        "content":"pokemon-others/pokemon-card-key",
        "nicename": "Pokémon - Card Key"
    },
    "pokemon-ss-ticket":{
        "type":"png",
        "content":"pokemon-others/pokemon-ss-ticket",
        "nicename": "Pokémon - SS Anne Ticket"
    },
    "pokemon-pass":{
        "type":"png",
        "content":"pokemon-others/pokemon-pass",
        "nicename": "Pokémon - Pass"
    },
    "pokemon-lost-item":{
        "type":"png",
        "content":"pokemon-others/pokemon-lost-item",
        "nicename": "Pokémon - Lost item"
    },
    "pokemon-radio":{
        "type":"png",
        "content":"pokemon-others/pokemon-radio",
        "nicename": "Pokémon - Radio"
    },
    "pokemon-expension-card":{
        "type":"png",
        "content":"pokemon-others/pokemon-expension-card",
        "nicename": "Pokémon - Extension"
    },
    "pokemon-red":{
        "type":"png",
        "content":"pokemon-others/pokemon-red",
        "nicename": "Pokémon - Red"
    },
    "pokemon-team-rocket":{
        "type":"png",
        "content":"pokemon-others/pokemon-team-rocket",
        "nicename": "Pokémon - Team Rocket"
    },
    "pokemon-secret-potion":{
        "type":"png",
        "content":"pokemon-others/pokemon-secret-potion",
        "nicename": "Pokémon - Secret potion"
    },
    "pokemon-squirt-bottle":{
        "type":"png",
        "content":"pokemon-others/pokemon-squirt-bottle",
        "nicename": "Pokémon - Squirt Bottle"
    },
    "pokemon-coin-case":{
        "type":"png",
        "content":"pokemon-others/pokemon-coin-case",
        "nicename": "Pokémon - Coin case"
    },
    "pokemon-pokegear":{
        "type":"png",
        "content":"pokemon-others/pokemon-pokegear",
        "nicename": "Pokémon - Pokégear"
    },
    "pokemon-machine-part":{
        "type":"png",
        "content":"pokemon-others/pokemon-machine-part",
        "nicename": "Pokémon - Machine part"
    },
}

export default PokemonOthers;